module.exports = __webpack_public_path__ + "static/flags/NI-b3c978fa13de5223574550b70aa9bed4.gif";